<template>
	<div v-if="item" class="item" :class="'item-' + item.card.slug">
		<div class="item-icon"><div class="img"></div></div>
		<div class="item-content">
			<div class="name">{{ item.card[lang].name }} <span v-if="item.nb > 1" class="nb">x{{ item.nb }}</span></div>
			<div class="effect">{{ item.card[lang].effect }}</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	name: 'item',
	props: [ 'item' ],
	computed: Object.assign(mapGetters([ 'lang' ]), {
		src: function() {
			// return require('@/assets/img/cards/icons/' + this.item.card.slug + '.png')
		}
	})
}
</script>

<style lang="stylus" scoped>
@import '../../../assets/css/app'
@import '../../../assets/css/items'

.item
	display block
	padding 8px
	font-size 1.6rem
	.item-icon
		float left
		width 32px
		height 32px
		margin 0 8px 0 0 
		.img
			width 32px
			height 32px
			background-image url(../../../assets/img/cards.png)
			background-repeat no-repeat
	.item-content
		margin-left 40px
		.name
			height 24px
			line-height (@height - 2px)
			white-space nowrap
			.nb
				position absolute
				right 0
				top 0
		.effect
			display block
			line-height 12px
			font-size 1.2rem
			color lighten(dark, 25%)

</style>
